import React, { Component } from "react";
import "./FeelingProud.css";
import  feelingProudImg from "../../assets/images/feelingProud.png";
class FeelingProud extends Component {
  render() {
    const theme = this.props.theme;

    return (
      <div  className="rotate-shadow-container">
      <img 
       alt="Feeling Proud"
          className="rotate-shadow-image"
        src={feelingProudImg}
        
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          // optional: if you want to react to theme
          // filter: theme.name === "dark" ? "brightness(0.9)" : "none",
        }}
      />
      </div>
    );
  }
}

export default FeelingProud;
